module.exports = __webpack_public_path__ + "static/media/octopusbit_drawn.a68b72fe.jpg";